export default __webpack_public_path__ + "static/media/2.7ab99d86.png";